export const callCallback = (cb: () => void) => cb();
